/**
 * Footer "Back to top": scrolls the element that actually scrolls the page (Horizon desktop scrolls
 * .page-wrapper, phones scroll the window), then releases focus so the next Tab starts at the top of
 * the document. Smooth unless the visitor prefers reduced motion.
 */

/** The element that scrolls the page. */
function getScroller() {
  const wrapper = document.querySelector('.page-wrapper');
  if (wrapper instanceof HTMLElement) {
    const overflow = getComputedStyle(wrapper).overflowY;
    if ((overflow === 'auto' || overflow === 'scroll') && wrapper.scrollHeight > wrapper.clientHeight) return wrapper;
  }
  return window;
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('[data-back-to-top]');
  if (!link) return;
  event.preventDefault();

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  getScroller().scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });

  // Hand focus back to the document so the next Tab starts at the top (the skip link).
  if (link instanceof HTMLElement) link.blur();
});
